import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { USER_ORGS } from '../types/userOrgs.js';
export const userOrgsDescriptor = {
    name: USER_ORGS,
    label: 'User Organization Refs',
    domain: 'vectorhub',
    collectionPath: 'user/{userId}/orgs',
    pathPatternKeys: { userId: 'string' },
    version: 1,
    description: 'User org membership refs at user/{userId}/orgs. Same collection SC uses in syscolect-ramme-2. VH reads only.',
    repositoryConfig: {
        dataSource: DataSourceStrategy.Firestore,
        cache: CacheStrategy.InMemory,
    },
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            maxLength: 128,
            description: '== doc id == orgId.',
        },
    ],
};
//# sourceMappingURL=userOrgs.descriptor.js.map